export const MARKET_TEST_IDS = {
  PAGE: 'market-page',
  EXPORT_BTN: 'market-export-btn',
  FILTER_DROPDOWN: 'market-filter-dropdown',
  STATUS_FILTER: 'market-status-filter',
  TABLE: 'market-table',
  TABLE_ROW: (id: string) => `market-table-row-${id}`,
  COL_MARKET_ID: (id: string) => `market-col-market-id-${id}`,
  COL_NAME: (id: string) => `market-col-name-${id}`,
  COL_LOCATION: (id: string) => `market-col-location-${id}`,
  COL_OPERATOR: (id: string) => `market-col-operator-id-${id}`,
  COL_STATUS: (id: string) => `market-col-status-${id}`,
  COL_CREATED_ON: (id: string) => `market-col-created-on-${id}`,
  COL_UPDATED_ON: (id: string) => `market-col-updated-on-${id}`,
} as const;
